import { useState } from "react";
import { H1, Card, abtn, abtnDanger, useLoad, act } from "../../components/admin/ui";
import { api, fileUrl, dt } from "../../lib/api";

const TABS = [["pending", "À vérifier"], ["approved", "Publiés"], ["rejected", "Refusés"]];

export default function ReviewsAdmin() {
  const [tab, setTab] = useState("pending");
  const [items, reload] = useLoad("/admin/reviews", { status: tab });
  const moderate = async (r, status) => { await act(() => api.post(`/admin/reviews/${r.id}`, { status }), status === "approved" ? "Avis publié" : "Avis refusé"); reload(); };
  return (
    <div data-testid="admin-reviews">
      <H1 sub="Avis laissés par des clients dont la commande est livrée. Rien n'est publié sans votre validation ; refusez uniquement les avis abusifs ou hors sujet, pas les avis négatifs honnêtes.">Avis clients</H1>
      <div className="flex gap-2 mb-6">{TABS.map(([k, l]) => <button key={k} data-testid={`reviews-tab-${k}`} onClick={() => setTab(k)} className={`${abtn} ${tab === k ? "border-emerald-500/60 text-emerald-300" : ""}`}>{l}</button>)}</div>
      {!items?.length && <p className="text-sm text-slate-500" data-testid="reviews-admin-empty">Aucun avis ici pour le moment.</p>}
      <div className="grid md:grid-cols-2 gap-4">
        {(items || []).map((r) => (
          <Card key={r.id} title={`${"★".repeat(r.rating)}${"☆".repeat(5 - r.rating)} · ${r.product_title}`}>
            <div className="text-xs text-slate-500 mb-2">{r.author} · {r.variant_name} · {dt(r.created_at)} · commande {r.order_id}</div>
            {r.title && <div className="font-medium mb-1">{r.title}</div>}
            <p className="text-sm text-slate-300">{r.text}</p>
            {r.photo && <img src={fileUrl(r.photo)} alt="" className="mt-3 w-40 h-40 object-cover" />}
            {tab === "pending" && <div className="flex gap-2 mt-4">
              <button data-testid={`review-approve-${r.id}`} onClick={() => moderate(r, "approved")} className={abtn}>Publier</button>
              <button data-testid={`review-reject-${r.id}`} onClick={() => moderate(r, "rejected")} className={abtnDanger}>Refuser</button>
            </div>}
          </Card>
        ))}
      </div>
    </div>
  );
}
